import { Pagination as PaginationLinks } from '@calendly/ui/components/pagination'
import { useDispatch, useSelector } from 'react-redux'

import { pushQueryParams } from 'actions/core/navigation'
import { ownerCollectionSelector, paginationSelector } from 'selectors/workflows'

import { TrialBanner } from '../trial_banner'
import { WorkflowTabs } from '../workflow_tabs'
import { Item as OwnerListItem } from './item'
import { NewWorkflowPopup } from './new_workflow_popup'

export const OwnerList = () => {
  const owners = useSelector(ownerCollectionSelector)
  const pagination = useSelector(paginationSelector)
  const dispatch = useDispatch()
  const showTabs = owners.some(({ type }) => type === 'user')

  return (
    <>
      <TrialBanner />
      {showTabs && <WorkflowTabs />}
      {
        owners.map((owner) => (
          <OwnerListItem
            key={`${owner.type}/${owner.id}`}
            owner={owner}
          />
        ))
      }
      <PaginationLinks
        currentPage={pagination.currentPage}
        totalPages={pagination.totalPages}
        onPageClick={(page) => {
          dispatch(pushQueryParams({ page }))
        }}
      />
      <NewWorkflowPopup />
    </>
  )
}
